import { ReportType } from '../constants/report'

/** Legacy report type keys persisted before ReportType migration. */
const LEGACY_REPORT_TYPE_BY_KEY: Record<string, ReportType> = {
  ADMISSION_GROUPS_SUMMARY: ReportType.TLPRO_RESERVATION_DUMP,
  UPCOMING_EVENT_TICKET_SUMMARY: ReportType.TLPRO_ADMISSION_DUMP,
  DAY_SUMMARY: ReportType.TLPRO_ADMISSION_GROUP_DUMP,
}

export function normalizeScheduledReportConfigReportType(
  reportType: unknown
): unknown {
  if (typeof reportType !== 'string') return reportType
  return LEGACY_REPORT_TYPE_BY_KEY[reportType] ?? reportType
}
